import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { segments } from 'data/actions';

import * as os from 'osutil';

class SegmentList extends Component {
  state = { };

  componentWillMount() {
  }

  renderSegemnts(segments) {
    return _.map(segments, (seg, key) => {
      return <span key={key}>{seg.name}</span>
    });
  }

  render() {

    return (
      <span className="segmentlist">
      <em>{this.props.label}</em>
      {this.props.segments && 
        <span>{this.renderSegemnts(this.props.segments)}</span>
      }
      </span>
    );
  }
}

function mapStateToProps(state, ownProps) {

  if (!ownProps.segments || !state || !state.segments.list.data)
  {
    return {};
  }
  return {
    segments: os.collection_by_keys(state.segments.list.data, Object.keys(ownProps.segments))
  };
}

const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...segments}, dispatch)
    };
}


export default connect(mapStateToProps, mapDispatch)(SegmentList)

  


// WEBPACK FOOTER //
// ./src/components/Lists/SegmentList.jsx